import { HashRouter as Router } from "react-router-dom";
import RoutesData from "./RoutesData";
// import { handleSystemEvenat } from "./components/useSystemEvents";
import { dispatch, subscribe } from "./components/eventBus";
import { useEffect, useState } from 'react';
import { startSSE } from "./components/realtime";
import axios from 'axios';
import "./App.css"
axios.defaults.withCredentials = true;

function App() {
  const [isServerUp, setIsServerUp] = useState(null); // null = checking, true/false = result


  useEffect(() => {
    const checkServer = async () => {
      try {
        const response = await fetch('https://localhost:5000/get-mac', {
          method: 'GET',
          signal: AbortSignal.timeout(3000), // 3s timeout
        });
        setIsServerUp(response.ok);
      } catch (error) {
        setIsServerUp(false);
      }
    };

    checkServer();

    const unsubscribe = subscribe((event) => {
      if (event.type === "SYSTEM_DISABLE_ALL") {
        sessionStorage.clear();
        window.location.reload();
      }
    });

    startSSE(dispatch);

    return () => unsubscribe();
  }, []);

  if (isServerUp === null) {
    return (
      <div className="status-page">
        <div className="status-card">
          <div className="spinner" />
          <p className="status-title">Checking system status</p>
          <p className="status-subtitle">This will just take a moment...</p>
        </div>
      </div>
    );
  }

  if (!isServerUp) {
    return (
      <div className="status-page">
        <div className="status-card error">
          <div className="icon-circle error">
            <svg width="50" height="50" viewBox="0 0 24 24" fill="none">
              <path d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a1 1 0 0 0 .86 1.5h18.64a1 1 0 0 0 .86-1.5L13.71 3.86a1 1 0 0 0-1.72 0z"
                stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <p className="status-subtitle">This is an <b>Un-Authorised System</b>. You cannot access QRmor application here.</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div
        style={{
          backgroundImage: "url(/QRmor.jpeg)",
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: 'no-repeat',
          position: 'fixed',
          width: '100vw',
          height: '100vh',
          top: '50px',
          left: '0',
          opacity: '0.07',
          zIndex: '9999',
          pointerEvents: "none"
        }}
      >
      </div>
      <RoutesData />
    </Router>
  );
}

export default App;
